var map = {
	"./ebanisteria.avif": 4837,
	"./electricos.avif": 735,
	"./estudiantil.avif": 3415,
	"./gas.avif": 7403,
	"./griferia.avif": 3847,
	"./tornilleria.avif": 7968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7438;